export enum Languages {
    EN = 'en',
    PL = 'pl',
    DE = 'de',
    ES = 'es',
}

export enum ApiLanguages {
    EN = 'EN',
    PL = 'PL',
    DE = 'DE',
    ES = 'ES',
}
